<template>
    <div class="case-screen-container main-container">
      <main-text-block :main-paragraph="mainParagraph"
                       :is-active-mini-paragraph="$isMobile"
                       v-animateonscroll="{ enterClass: 'fade-in'}"
                       @animationend="showAnimation"
                       :config-block="{
                          theme: 'dark',
                          textAlign: this.$isMobile ? 'left' : 'center',
                       }"
                       :main-title="mainTitle"/>
      <div class="slider-container" v-if="!$isMobile">
        <div class="img-container" v-for="item in 5"
             :class="['animation-opacity', {'is-active-opacity' : isVisible(item - 1)}]"
             :key="item">
          <img :src="getUrlLogo('logo')" alt="logo">
        </div>
      </div>
      <slider-banner :cards-info="array"
                     :is-active-row="true"
                     :is-active-padding="false"
                     :class-name="'card-case-wrapper'"
                     v-else>
        <template v-slot:card="{ item }">
          <img :src="getUrlLogo('logo')" alt="logo">
        </template>
      </slider-banner>
    </div>
</template>

<script>
import MainTextBlock from "@/components/entities/blocks/MainTextBlock.vue";
import SliderBanner from "@/components/entities/SliderBanner.vue";

export default {
  name: "CaseScreen",
  components: {SliderBanner, MainTextBlock},
  data() {
    return {
      lengthAnimation: 5,
      visibleIndexItem: -1,
      mainTitle: 'Наши кейсы',
      mainParagraph: 'Lorem ipsum dolor sit amet consectetur. Duis ac nulla quis semper molestie adipiscing proin. Cursus sit nisl etiam facilisis mauris volutpat risus. '
    }
  },
  computed: {
    array() {
      return Array(5).fill(5).map(item => ({
        id: item
      }))
    }
  }
}
</script>

<style scoped lang="scss">
  .case-screen-container {
      background-color: var(--color-white);
      align-items: center;
      flex-direction: column;
    .slider-container {
      width: 100%;

      .img-container {
        display: flex;
        width: 100%;
        height: 100%;
        & img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (max-width: 3024px){
    .case-screen-container {
      padding-bottom: 100px;
      row-gap: 60px;
      .main-block-container {
        max-width: 820px;
      }
      .slider-container {
        column-gap: 94px;

        .img-container {
          padding: 36px;
        }
      }
    }
  }

  @media (max-width: 1920px) {
    .case-screen-container {
      padding-bottom: 85px;
      row-gap: 60px;
      .main-block-container {
        max-width: 820px;
      }
      .slider-container {
        column-gap: 85px;

        .img-container {
          padding: 25px;
        }
      }
    }
  }
  @media (max-width: 1600px) {
    .case-screen-container {
      padding-bottom: 70px;
      row-gap: 60px;
      .main-block-container {
        max-width: 820px;
      }
      .slider-container {
        column-gap: 70px;

        .img-container {
          padding: 24px;
        }
      }
    }
  }
  @media (max-height: 800px) {

    .case-screen-container {
      padding-bottom: 55px;
      row-gap: 40px;
      .main-block-container {
        max-width: 569px;
      }
      .slider-container {
        column-gap: 93px;

        .img-container {
          padding: 16px;
        }
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .case-screen-container {
      padding-bottom: 70px;
      row-gap: 60px;
      .main-block-container {
        max-width: 820px;
      }
      .slider-container {
        column-gap: 70px;

        .img-container {
          padding: 24px;
        }
      }
    }
  }

  @media (max-width: 1133px) {
    .case-screen-container {
      padding-bottom: 55px;
      row-gap: 40px;
      .main-block-container {
        max-width: 569px;
      }
      .slider-container {
        column-gap: 93px;

        .img-container {
          padding: 16px;
        }
      }
    }
  }
  @media (max-width: 769px) {
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .case-screen-container {
      padding-bottom: 180px;
      row-gap: 120px;
      .main-block-container {
        max-width: 1639px;
      }
      .slider-container {
        column-gap: 230px;

        .img-container {
          padding: 64px;
        }
      }
    }
  }

</style>